import React from 'react';
import Username from './../common/Username';
import Avatar from './../common/Avatar';
import Moment from 'react-moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const ActivityFeedPost = (props) => (
    <li className="media">
        <div className="row">
            <div className="col-xs-2">
                <Avatar image={props.users[props.item.user].avatar} rank={props.ranks[props.users[props.item.user].rank]} width="32" height="32" />
            </div>
            <div className="col-xs-10">
                <Username user={props.users[props.item.user]} rank={props.ranks[props.users[props.item.user].rank]} placement="left" />
                <span className="activity-date text-muted"> posted </span>
                <span className="timestamp">
                    <OverlayTrigger placement="top" overlay={<Tooltip id="activity-feed-post-date"><Moment format="ddd MMM D YYYY">{props.item.created}</Moment></Tooltip>}>
                        <Moment fromNow>{props.item.created}</Moment>
                    </OverlayTrigger>
                </span>
                <p>{props.item.feedPost.body}</p>
            </div>
        </div>
    </li>
);


export default ActivityFeedPost;



// WEBPACK FOOTER //
// ./src/ActivityFeed/ActivityFeedPost.js